import slidesLQOP1 from './slides_LQOP1';
import { featuresLQOP1 } from './features_LQOP1';
import { ProjectType } from '../../../../Constants';
import { textLQOP1 } from './text_LQOP1';

export const LQOP1data = {

    fr:{
        id: 8,
        name: 'Le Boréal',
        content: textLQOP1.fr,
        yearBuilt: 2026,
        address: "8 Rue Notre Dame, Charlemagne, QC J5Z 0H2",
        city: "Charlemagne",
        brand: "quartier-oviv",
        projectPage: "quartier-oviv",
        website: "https://www.quartieroviv.ca",
        category: ProjectType.Residential,
        images: slidesLQOP1,
        features: featuresLQOP1.fr
    },
    en:{
        id: 8,
        name: 'Le Boréal',
        content: textLQOP1.en,
        yearBuilt: 2026,
        address: "8 Rue Notre Dame, Charlemagne, QC J5Z 0H2",
        city: "Charlemagne",
        brand: "quartier-oviv",
        projectPage: "quartier-oviv",
        website: "https://www.quartieroviv.ca",
        category: ProjectType.Residential,
        images: slidesLQOP1,
        features: featuresLQOP1.en
    }
}